import {useState} from 'react';
import {useAuthContext} from './AuthContext';
import {api} from 'api';
// import {downloadFileFromStream} from 'api/downloadFileStream';
// import {Msg} from 'components/notifications/NotificationContext';
import {downloadFile} from 'api/downloadFile';
import {getFileName} from 'utils';

const downloadEncrypted = async (path: string) => {
   // Example usage of the function
   const url = `${api.download}?path=${path}`;
   // const privateKeyArmored = privateKey;

   const passphrase = undefined; //'your-passphrase';
   // const fileName = 'decrypted_output.txt';

   downloadFile(url, getFileName(path).name);

   // return downloadFileFromStream(url, {})
   //    .then((name) => {
   //       console.debug('download file', name);
   //       Msg.notify(`File "${name}" successfuly downloaded.`, 'success');
   //    })
   //    .catch((error) => {
   //       console.error('Error during downloading:', error);
   //       Msg.notify('Error during downloading:' + (error as Error).message, 'error');
   //    });

   // return fetchAndDecryptStreamOnTheFly(url, privateKeyArmored, passphrase)
   //    .then(() => {
   //       console.log('Decryption and saving completed successfully.');
   //    })
   //    .catch((error) => {
   //       console.error('Error during decryption:', error);
   //       toast.error('Error during decryption:' + (error as Error).message);
   //    });
};

export const useOpenPGP = () => {
   const [privateKey, setPrivateKey] = useState('');
   const {
      authData: {pgpPublicKey: publicArmoredKey},
   } = useAuthContext();

   // const generateSendKey = useCallback(async () => {
   //    const {privateKey, publicKey} = await generateKey({
   //       userIDs: {name: 'Test', email: 'test@test.test'},
   //    });
   //    setPrivateKey(privateKey);

   //    send(`${API_SERVER}/setkey`, publicKey);
   // }, [setPrivateKey]);

   // useEffect(() => {
   //    generateSendKey();
   // }, [generateSendKey]);

   return {
      privateKey,
      publicArmoredKey,

      // generateSendKey,
      // sendEncrypted,
      downloadEncrypted,
   };
};
